var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"introduction"},[_vm._m(0),_c('ButtonComponent',{staticClass:"start",on:{"click":function($event){$event.preventDefault();return _vm.next.apply(null, arguments)}}},[_vm._v("Démarrer")]),_c('div',{staticClass:"sun"})],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('h1',{staticClass:"introduction_title"},[_vm._v(" b-green "),_c('span',[_vm._v("par Bewizyu")])])
}]

export { render, staticRenderFns }